var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.848 19.0535H30.9999C24.3055 19.0535 18.8787 24.4803 18.8787 31.1747V116.023C18.8787 122.718 24.3055 128.144 30.9999 128.144H115.848C122.543 128.144 127.97 122.718 127.97 116.023V31.1747C127.97 24.4803 122.543 19.0535 115.848 19.0535Z",
    fill: "#CDD6D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.212 61.4778C57.2328 61.4778 61.3029 57.4077 61.3029 52.3869C61.3029 47.3662 57.2328 43.296 52.212 43.296C47.1912 43.296 43.1211 47.3662 43.1211 52.3869C43.1211 57.4077 47.1912 61.4778 52.212 61.4778Z",
    stroke: "white",
    strokeWidth: 3.0303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.969 91.7809L97.6664 61.4778L30.9998 128.144",
    stroke: "white",
    strokeWidth: 3.0303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/uploadImg.e146aedc27ecb0a23b4687dfefc777c1.svg";
export { ForwardRef as ReactComponent };